/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: campaign.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { requirePostForm, type RequestOptions, type Transport } from '../transport';

import type {
  CreateCampaignRequest,
  CreateCampaignResponse,
  DeleteCampaignRequest,
  DeleteCampaignResponse,
  GetCampaignRequest,
  GetCampaignResponse,
  ListCampaignsRequest,
  ListCampaignsResponse,
} from '../types/campaign';

export const createCampaignService = (transport: Transport) => ({
  async createCampaign(
    request: CreateCampaignRequest,
    options: RequestOptions = {},
  ): Promise<CreateCampaignResponse> {
    const { organization_id, program_id, ...data } = request;
    const url = getApiPath(API_METHODS.CampaignService.CreateCampaign, {
      organization_id,
      program_id,
    });
    const formData = new FormData();
    if (data.name !== undefined) {
      formData.append('name', String(data.name));
    }
    if (data.workflow_id !== undefined) {
      formData.append('workflow_id', String(data.workflow_id));
    }
    if (data.file_data) {
      // Handle File, Blob, or Uint8Array (from proto bytes)
      const fileValue =
        data.file_data instanceof Blob ? data.file_data : new Blob([data.file_data] as BlobPart[]);
      formData.append('file', fileValue);
    }
    if (data.file_type !== undefined) {
      formData.append('file_type', String(data.file_type));
    }
    const postForm = requirePostForm(transport, 'CampaignService.CreateCampaign');
    return postForm<CreateCampaignResponse>(url, formData, options);
  },

  async listCampaigns(
    request: ListCampaignsRequest,
    options: RequestOptions = {},
  ): Promise<ListCampaignsResponse> {
    const { organization_id, program_id, workflow_id, ...params } = request;
    const url = getApiPath(API_METHODS.CampaignService.ListCampaigns, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.get<ListCampaignsResponse>(url, { params, ...options });
  },

  async getCampaign(
    request: GetCampaignRequest,
    options: RequestOptions = {},
  ): Promise<GetCampaignResponse> {
    const { organization_id, program_id, campaign_id } = request;
    const url = getApiPath(API_METHODS.CampaignService.GetCampaign, {
      organization_id,
      program_id,
      campaign_id,
    });
    return transport.get<GetCampaignResponse>(url, options);
  },

  async deleteCampaign(
    request: DeleteCampaignRequest,
    options: RequestOptions = {},
  ): Promise<DeleteCampaignResponse> {
    const { organization_id, program_id, campaign_id } = request;
    const url = getApiPath(API_METHODS.CampaignService.DeleteCampaign, {
      organization_id,
      program_id,
      campaign_id,
    });
    return transport.delete<DeleteCampaignResponse>(url, options);
  },
});

export type CampaignService = ReturnType<typeof createCampaignService>;
